<template>
  <div class="show-container" v-if="hasData">
    <div class="external-info">
      <div class="column-box" v-if="data.columnPanel && data.columnPanel !== null && data.columnPanel.items.length > 0">
        <ul class="clearfix">
          <li class="cell" v-for="item in data.columnPanel.items">
            <div class="s-total-data" :class="item.highlight ? 'ongoing' : ''">
              <span class="num">{{ item.value }}</span>
              <span class="name">{{ item.label }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="unit-info" v-if="data.unit && data.unit !== null"><b>单位</b>：{{ data.unit }}</div>
    </div>
    <div style="height: 100%;" :id="id"></div>
  </div>
  <show-no-data v-else></show-no-data>
</template>

<script>
  import eCharts from 'echarts'
  import 'echarts/theme/macarons'
  import ColumnConfig from './column-config'
  import analyseUtil from '../analyse-util'
  import ShowNoData from '../show-no-data'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    components: {
      ColumnConfig,
      ShowNoData
    },
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'pie-config',
    typeCode: '3',
    data() {
      return {
        id: analyseUtil.randomId(),
        myChart: {},
        options: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            x: 'right',
            top: '10%',
            data: null
          },
          series: []
        }
      }
    },
    computed: {
      hasNoZero: function () {
        let hasNoZero = false
        for (let i = 0; i < this.data.data.length; i++) {
          hasNoZero = this.data.data[i].value ? this.data.data[i].value !== 0 : false
          if (hasNoZero) {
            break
          }
        }
        return hasNoZero
      },
      hasData: function () {
        return this.data.data !== null && this.data.data.length > 0 && this.hasNoZero
      },
      legendData: function () {
        let data = []
        for (let i = 0; i < this.data.data.length; i++) {
          data.push(this.data.data[i].name)
        }
        return data
      },
      seriesCenter: function () {
        if (this.data.showLegend !== undefined && this.data.showLegend !== null && this.data.showLegend) {
          return ['35%', '55%']
        } else {
          return ['50%', '55%']
        }
      }
    },
    mounted() {
      if (this.hasData) {
        this.loadChart()
        addResizeListener(this.$el, this.resizeListener)
      }
    },
    beforeDestroy() {
      if (this.hasData) {
        removeResizeListener(this.$el, this.resizeListener)
      }
    },
    methods: {
      resizeListener: function () {
        this.$nextTick(() => {
          if (this.myChart !== null) {
            this.myChart.resize()
          }
        })
      },
      getValueSeries: function () {
        let series = {
          label: {
            normal: {
              formatter: '{b} {d}%',
              show: this.data.showLabel !== undefined && this.data.showLabel
            }
          },
          labelLine: {
            show: true,
            length: 20
          },
          itemStyle: {
            normal: {
              opacity: 0.8
            }
          },
          color: analyseUtil.COLORS,
          radius: ['55%', '70%'],
          type: 'pie',
          center: this.seriesCenter,
          data: this.data.data
        }
        if (this.data.innerContent && this.data.innerContent !== null) {
          let vm = this
          series.label = {
            normal: {
              show: true,
              position: 'center',
              color: '#565656',
              formatter: function (argument) {
                return vm.data.innerContent
              },
              textStyle: {
                fontSize: 16
              }
            }
          }
        }
        return series
      },
      getInnerSeries: function () {
        return {
          type: 'pie',
          radius: [0, '45%'],
          center: this.seriesCenter,
          color: analyseUtil.COLOR_SCHEME_A,
          itemStyle: {
            normal: {
              opacity: 0.8
            }
          },
          label: {
            normal: {
              show: true,
              formatter: function (param) {
                if (param.percent === 0) {
                  return ''
                } else {
                  return param.percent + '%'
                }
              },
              position: 'inner'
            }
          },
          data: this.data.innerPie
        }
      },
      loadChart: function () {
        this.myChart = eCharts.init(document.getElementById(this.id), 'shine')
        this.options.legend.data = this.legendData
        this.options.series.push(this.getValueSeries())
        if (this.data.unit && this.data.unit !== null) {
          this.options.legend.top = '26%'
        }
        if (this.data.columnPanel && this.data.columnPanel !== null && this.data.columnPanel.items.length > 0) {
          this.options.legend.top = '30%'
        }
        if (this.data.innerPie && this.data.innerPie.length > 0) {
          this.options.series.push(this.getInnerSeries())
        }
        if (this.data.showLegend !== undefined && this.data.showLegend !== null && !this.data.showLegend) {
          delete this.options['legend']
        }
        this.myChart.setOption(this.options)
        this.myChart.hideLoading()
      }
    }
  }
</script>

<style scoped>

  .column-box {
    position: absolute;
    right: 0;
    top: 10px;
  }

  .external-info {
    position: relative;
    width: 100%;
  }

  .unit-info {
    position: absolute;
    left: 20px;
    top: 10px;
  }

  .cell:first-child {
    padding-left: 0;
  }

  .cell:last-child {
    border-right: 0;
  }

  .cell:last-child .s-total-data {
    border-right: 0;
  }

  .cell {
    position: relative;
    text-align: center;
    float: left;
  }

  .s-total-data {
    border-right: 1px solid #eee;
    padding: 0 10px;
  }

  .s-total-data.ongoing .num {
    color: #3b56ce;
  }

  .s-total-data.ongoing .name {
    color: #3b56ce;
    opacity: 0.8;
    filter: alpha(opacity=80);
  }

  .s-total-data .num {
    font-family: "Gill Sans", "Gill Sans MT", "Myriad Pro", "DejaVu Sans Condensed", Helvetica, Arial, "sans-serif";
    font-size: 20px;
    font-weight: 500;
    color: #222;
  }

  .s-total-data span {
    display: block;
    line-height: 1;
  }

  .s-total-data .name {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
  }

  .s-total-data span {
    display: block;
    line-height: 1;
  }

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/pie-config.vue